import gql from 'graphql-tag';

const UPDATE_MILESTONE = gql`
  mutation updateMilestone($data: MilestoneUpdateInput!, $where: MilestoneWhereUniqueInput!) {
    updateMilestone(data: $data, where: $where) {
      id
      name
      description
      startDate
      dueDate
      status
      createdAt
      updatedAt
      project {
        id
        name
      }
      tasks {
        id
        name
        status
      }
    }
  }
`;

export default UPDATE_MILESTONE;
